import { render, staticRenderFns } from "./the-thao.vue?vue&type=template&id=f2bd64ba&"
import script from "./the-thao.vue?vue&type=script&lang=js&"
export * from "./the-thao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports